/** Helpers shared by the Calls tab screens. */
import type { ZcrmActivity } from "../providers/zinspector/activities";

/** "2026-10-09T14:30" in local time, for a datetime-local input. */
export const toLocalInput = (date: Date): string => {
  const local = new Date(date.getTime() - date.getTimezoneOffset() * 60_000);
  return local.toISOString().slice(0, 16);
};

const time = (activity: ZcrmActivity) =>
  Date.parse(activity.starts_at ?? activity.updated_at) || 0;

/** Upcoming soonest first; past most recent first. */
export const splitActivities = (activities: ZcrmActivity[]) => ({
  upcoming: activities
    .filter((a) => !a.is_done)
    .sort((a, b) => time(a) - time(b)),
  past: activities.filter((a) => a.is_done).sort((a, b) => time(b) - time(a)),
});
